module.exports = __webpack_public_path__ + "static/04-749bdff4f3bcb3e59649d3eabd71b2e8.png";